angular.module('app.resources', ['ngResource']).factory('APIEventdata', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/exhibitor_data.json",
  {
      _private: true,
      role: 'presenter'
    });
  }
]).factory('APIExhibitors', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/exhibitors/:id",
  {
      id: '@id'
    });
  }
]).factory('APICheckin', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/tickets/:shortcode/:action",
  {
      action: '@action'
    });
  }
]).factory('APIInquiries', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/inquiries.json");
  }
]).factory('APIVisitor', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/visitors.json",
  {
      _visitor: true
    });
  }
]).factory('APIInteractions', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/interactions.json",
  {},
  {
      save: {
        method: 'POST',
        params: {
          _private: true
        }
      }
    });
  }
]).factory('APIFavoritesTable', [
  'Tablify',
  function(Tablify) {
    return Tablify("api2.php");
  }
]).factory('APIFavorites', [
  '$resource',
  function($resource) {
    return $resource("api2.php?shortcode=:shortcode",
  {
      shortcode: '@shortcode'
    });
  }
]).factory('APIReadTable', [
  'Tablify',
  function(Tablify) {
    return Tablify("api3.php");
  }
]).factory('APIRead', [
  '$resource',
  function($resource) {
    return $resource("api3.php");
  }
]).factory('APIData', [
  '$resource',
  function($resource) {
    return $resource("core/data/data-:slug.json",
  {
      slug: '@slug'
    });
  }
]).factory('APIStatistics', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/statistics");
  }
]).factory('APIScan', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/:qrcode/scanning",
  {
      auth_token: '@auth_token',
      exhibitor_id: '@exhibitor_id',
      _scan: true
    },
  {
      scan: {
        method: 'PUT'
      }
    });
  }
]).factory('APIRead2Table', [
  'Tablify',
  function(Tablify) {
    return Tablify("api_read.php");
  }
]).factory('APIRead2', [
  '$resource',
  function($resource) {
    return $resource("api_read.php");
  }
]).factory('APIForm', [
  '$resource',
  function($resource) {
    return $resource("api7.php");
  }
]).factory('APIPrograms', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/schedule");
  }
]).factory('APISpeakers', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/schedule/speakers/:id");
  }
]).factory('APISlots', [
  '$resource',
  function($resource) {
    return $resource("api.php?path=/schedule/slots/:id",
  {
      id: '@id'
    });
  }
]);
